export default __webpack_public_path__ + "static/media/show_logo.542f6699.jpeg";